import React from "react";
import { useIntl } from "react-intl";

import { RichText } from "@learningblocks/shared-components/lib/RichText";

import { TableCellProps } from "../types";
import { listCellClass } from "../TableQuestion.css";

export interface ListCellProps
  extends Pick<TableCellProps, "cellId" | "text" | "colspan"> {
  bgColor?: string;
}

export const ListCell: React.FC<ListCellProps> = ({
  cellId,
  text,
  colspan,
  bgColor,
}) => {
  const intl = useIntl();

  const translatedText = text
    ? intl.formatMessage({ id: text, defaultMessage: text })
    : "";

  const style = {
    ...(bgColor && { backgroundColor: bgColor }),
  };

  return (
    <td
      key={cellId}
      className={listCellClass}
      colSpan={colspan ? Number(colspan) : undefined}
      style={style}
    >
      <RichText value={translatedText} />
    </td>
  );
};
